const ResponsavelFrete = {
  EMITENTE: 'Por conta do emitente',
  DESTINATARIO_REMETENTE: 'Por conta do destinatário/remetente',
  TERCEIROS: 'Por conta de terceiros',
  SEM_FRETE: 'Sem frete',
};

export default ResponsavelFrete;
